import enUS from './en-US'
import es from './es'
import ca from './ca'

export default {
  'en-US': enUS,
  es: es,
  ca: ca,
}
